export const SiselseCities = [
  {
    id: 1,
    city: "MAZATLÁN",
  },
  {
    id: 2,
    city: "CULIACÁN",
  },
  {
    id: 3,
    city: "LOS MOCHIS",
  },
  {
    id: 4,
    city: "TIJUANA",
  },
  {
    id: 5,
    city: "MONTERREY",
  },
  {
    id: 6,
    city: "AGUASCALIENTES",
  },
];

export const SiselseCardsTypes = [
  {
    id: 3,
    type: "TARJETA PEATONAL",
    cost: 0,
  },
  {
    id: 4,
    type: "PROXIMIDAD",
    cost: 0,
  },
  {
    id: 5,
    type: "TARJETA VEHICULAR", //UHF LIBRE
    cost: 0,
  },
  {
    id: 6,
    type: "STICKER", // STICKER LIBRE
    cost: 0,
  },
  {
    id: 7,
    type: "STICKER", //STICKER 2362
    cost: 0,
  },
  {
    id: 8,
    type: "STICKER", //STICKER 1234
    cost: 0,
  },
  {
    id: 9,
    type: "TARJETA VEHICULAR", //UHF 2362
    cost: 0,
  },
  {
    id: 10,
    type: "TARJETA VEHICULAR", //UHF 1234
    cost: 0,
  },
  {
    id: 11,
    type: "TAG", //TAG LIBRE
    cost: 0,
  },
  {
    id: 12,
    type: "TAG", // TAG 2362
    cost: 0,
  },
  {
    id: 13,
    type: "TAG", // TAG 1234
    cost: 0,
  },
  {
    id: 14,
    type: "BRAZALETE",
    cost: 0,
  },
  {
    id: 16,
    type: "STICKER ACCESS PRO", //STICKER ACCESSP
    cost: 0,
  },
];

export interface SiselseCardsAvailableStatus {
  title: string;
  color: string;
  icon: string;
}

export const SiselseCardsStatus: {
  [key: string]: SiselseCardsAvailableStatus;
} = {
  Capturada: {
    title: "Capturada",
    color: "dark",
    icon: "create-sharp",
  },
  Activa: {
    title: "Activada",
    color: "success",
    icon: "checkmark-circle",
  },
  EnProceso: {
    title: "En proceso",
    color: "success",
    icon: "rocket",
  },
  Entregada: {
    title: "Entregada",
    color: "success",
    icon: "checkmark-circle",
  },
  Pagada: {
    title: "Pagada",
    color: "success",
    icon: "cash",
  },
  Solicitada: {
    title: "Solicitada",
    color: "dark",
    icon: "clipboard-sharp",
  },
};
